import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=42f66892&scoped=true&"
import script from "./OrderItem.vue?vue&type=script&lang=ts&"
export * from "./OrderItem.vue?vue&type=script&lang=ts&"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=42f66892&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f66892",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseClickedCheckbox: require('/usr/www/nuxt/components/Base/BaseClickedCheckbox.vue').default})
